module.exports = __webpack_public_path__ + "static/media/ios-phone-portrait.df7ab2eb.svg";